module.exports = __webpack_public_path__ + "static/media/volume_off.0bfee39d.svg";